<template>
    <div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Nombre</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Nombre"
                                readonly
                                type="text"
                                v-model="servicio_json.nombre"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Código de integración</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-barcode"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Código de integración"
                                readonly=""
                                v-model="servicio_json.UUID"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label
                            >Confirmable (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir realizar la confirmación de las horas de este servicio."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                v-model="servicio_json.confirmable"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label
                            >Confirmable General (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Confirmar todas las citas de este servicio sin importar el profesional."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                v-model="servicio_json.confirmable_general"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <label>Mensaje de confirmación</label>
                        <textarea
                            class="form-control"
                            rows="3"
                            v-model="servicio_json.mensaje_confirmacion"
                            placeholder="Mensaje personalizado de confirmación"
                        ></textarea>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Piso de atención</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="servicio_json.piso_atencion"
                            placeholder="Ej: Piso 3"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Duracion</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Nombre"
                                readonly
                                type="text"
                                v-model="servicio_json.duracion"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4" v-if="servicio_json.area">
                    <div class="form-group">
                        <label>Area</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Nombre"
                                readonly
                                type="text"
                                v-model="servicio_json.area.nombre"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Especialidad</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Nombre"
                                readonly
                                type="text"
                                v-model="servicio_json.especialidad.nombre"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label
                            >Preparación(<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Dias que se deben tener de preparacion para el usuario."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-clock"></i>
                                </span>
                            </div>
                            <input
                                class="form-control"
                                placeholder="Dias de preparacion"
                                type="number"
                                v-model="servicio_json.dias_preparacion"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Flujo</label>
                        <div class="input-group">
                            <select
                                class="custom-select"
                                v-model="servicio_json.id_flujo"
                            >
                                <option disabled value="">
                                    Seleccione un elemento
                                </option>
                                <option
                                    v-for="(flujo, index) in flujos_list"
                                    :key="index"
                                    v-bind:value="flujo.id"
                                >
                                    {{ flujo.nombre }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Indicaciones</label>
                        <div class="input-group">
                            <textarea
                                class="form-control"
                                rows="4"
                                v-model="servicio_json.indicaciones"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Texto Personalizado Voucher Agendamiento</label>
                        <div class="input-group">
                            <textarea
                                class="form-control"
                                rows="2"
                                v-model="
                                    servicio_json.texto_personalizado_agendamiento
                                "
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="hr-line-dashed"></div>
                    <h2>Video Explicativo</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Etiqueta del video (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Texto descriptivo que se mostrará como link en los vouchers."
                                ><i class="fa fa-question-circle"></i></a>)</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-tag"></i>
                                </span>
                            </div>
                            <input
                                placeholder="Ej: Ver video explicativo"
                                type="text"
                                v-model="servicio_json.label_video_explicativo"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                        <label>URL del video explicativo (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Enlace al video explicativo asociado a este servicio. Se mostrará en los vouchers de pacientes."
                                ><i class="fa fa-question-circle"></i></a>)</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-addon"
                                    ><i class="fal fa-video"></i>
                                </span>
                            </div>
                            <input
                                placeholder="https://..."
                                type="url"
                                v-model="servicio_json.url_video_explicativo"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label
                            >Agendable (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir agendar."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                @change="handleAgendableChange()"
                                id="cb-agendable"
                                v-model="servicio_json.agendable"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label
                            >Agendable Web (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir agendar via web."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                @change="changeAgendable('web')"
                                id="cb-agendable-web"
                                v-model="servicio_json.agendable_web"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label
                            >Agendable Ejecutivo (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir agendar via web a ejecutivos."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                @change="changeAgendable('ejecutivo')"
                                id="cb-agendable-ejecutivo"
                                v-model="servicio_json.agendable_ejecutivo"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label
                            >Agendable Whatsapp (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir agendar via canal whatsapp."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                @change="changeAgendable('whatsapp')"
                                id="cb-agendable-whatsapp"
                                v-model="servicio_json.agendable_whatsapp"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label
                            >Agendable Teléfono (<a
                                class="text-navy"
                                data-toggle="popover"
                                data-placement="auto"
                                data-content="Permitir agendar via canal teléfono."
                                ><i class="fa fa-question-circle"></i></a
                            >)</label
                        >
                        <div class="input-group">
                            <input
                                @change="changeAgendable('telefono')"
                                id="cb-agendable-telefono"
                                v-model="servicio_json.agendable_telefono"
                                type="checkbox"
                                class="js-switch"
                                data-switchery="true"
                                style="display: none"
                            />
                        </div>
                    </div>
                </div>
            </div>


            <hr v-if="list.length > 0" />
            <div
                class="row"
                v-for="(item, index) in list"
                :key="index"
                style="border-bottom: 1px solid #bfbfbfee; margin-bottom: 16px"
            >
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Establecimiento {{ index + 1 }}</label>
                        <div class="input-group">
                            <multiselect
                                label="nombre"
                                :multiple="true"
                                :taggable="true"
                                track-by="id"
                                v-model="item.establecimientos"
                                :options="establecimientos_list"
                            ></multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Estrategia {{ index + 1 }}</label>
                        <div class="input-group">
                            <select
                                class="custom-select"
                                v-model="item.estrategia"
                            >
                                <option disabled value="">
                                    Seleccione un elemento
                                </option>
                                <option
                                    v-for="(
                                        estrategia, index3
                                    ) in estrategias_list"
                                    :key="index3"
                                    v-bind:value="estrategia.id"
                                >
                                    {{ estrategia.nombre }}
                                </option>
                            </select>
                            <!-- <input placeholder="Abreviatura" v-model="item.estrategia" type="text" class="form-control" /> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Tipo Cita {{ index + 1 }}</label>
                        <div class="input-group">
                            <multiselect
                                label="abrev"
                                :multiple="true"
                                :taggable="true"
                                track-by="id"
                                v-model="item.tipo_citas"
                                :options="tipo_cita_list"
                            ></multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Eliminar</label>
                        <div class="input-group">
                            <button
                                class="btn btn-secondary"
                                @click="eliminar(index)"
                            >
                                <i class="fal fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <a href="javascript:void(0)" @click="add"
                        >Añadir Estrategia</a
                    >
                </div>
            </div>

            <!-- Indicaciones Correo Section moved to bottom -->
            <div class="row">
                <div class="col">
                    <div class="hr-line-dashed"></div>
                    <h2>Indicaciones Correo</h2>
                    <div class="hr-line-dashed"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="dropzone" id="dropzoneServicio">
                    </div>
                </div>
            </div>
        </div>
        <div class="ibox-footer">
            <div class="row">
                <div class="col-md-4 offset-md-8">
                    <div class="btn-group float-right">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            @click="save"
                        >
                            <i class="fal fa-save"></i> Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
    components: { Multiselect },
    props: [
        "servicio",
        "establecimientos",
        "estrategias",
        "tipo_cita",
        "id",
        "test_ab",
        "flujos",
    ],
    data() {
        return {
            servicio_json: {
                especialidad: {
                    nombre: null,
                },
                archivos_adjuntos: [],
            },
            list: [],
            establecimientos_list: [],
            estrategias_list: [],
            tipo_cita_list: [],
            flujos_list: [],
            archivos_nuevos: [],
            eliminar_archivos: [],
        };
    },
    mounted() {
        this.servicio_json = JSON.parse(this.servicio);
        this.estrategias_list = JSON.parse(this.estrategias);
        this.establecimientos_list = JSON.parse(this.establecimientos);
        this.tipo_cita_list = JSON.parse(this.tipo_cita);
        this.flujos_list = JSON.parse(this.flujos);
        if (this.servicio_json.id_flujo === null) {
            this.servicio_json.id_flujo = 1;
        }

        let establecimientos = [];
        let tipo_citas = [];
        // console.log(this.test_ab);
        this.list = JSON.parse(this.test_ab).map((element) => {
            establecimientos = [];
            tipo_citas = [];
            const map_establecimientos = new Map();
            const map_tipo_cita = new Map();
            for (const item of element.establecimientos) {
                if (!map_establecimientos.has(item.id_establecimiento)) {
                    map_establecimientos.set(item.id_establecimiento, true); // set any value to Map
                    establecimientos.push(item.establecimiento);
                }
                // console.log(item);
                if (!map_tipo_cita.has(item.id_tipocita)) {
                    map_tipo_cita.set(item.id_tipocita, true); // set any value to Map
                    tipo_citas.push(item.tipo_cita);
                }
            }
            return {
                establecimientos: establecimientos,
                estrategia: element.estrategia.id,
                tipo_citas: tipo_citas,
                id: element.id,
            };
        });

        // console.log(this.list);
        // this.handleAgendableChange();

        // Initialize Dropzone
        var vm = this;
        this.dropzone = new window.Dropzone("#dropzoneServicio", {
            url: "/admin/configurar/upload",
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 5,
            maxFiles: 10,
            addRemoveLinks: true,
            dictDefaultMessage: "<strong>Arrastra tus archivos aquí o haz clic para cargar.</strong>",
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            init: function() {
                var myDropzone = this;

                function getIconClass(filename) {
                    var ext = filename.split('.').pop().toLowerCase();
                    switch (ext) {
                        case 'pdf': return 'fa-file-pdf';
                        case 'doc':
                        case 'docx': return 'fa-file-word';
                        case 'xls':
                        case 'xlsx': return 'fa-file-excel';
                        case 'ppt':
                        case 'pptx': return 'fa-file-powerpoint';
                        case 'zip':
                        case 'rar': return 'fa-file-archive';
                        case 'txt': return 'fa-file-alt';
                        case 'csv': return 'fa-file-csv';
                        default: return 'fa-file';
                    }
                }

                this.on("addedfile", function(file) {
                    if (file.type && !file.type.match(/image.*/)) {
                        var iconClass = getIconClass(file.name);
                        var dzImage = file.previewElement.querySelector(".dz-image");
                        if (dzImage) {
                            dzImage.innerHTML = '<div class="text-center" style="padding-top: 20px;"><i class="fal ' + iconClass + '" style="font-size: 60px; color: #676a6c;"></i></div>';
                            dzImage.style.backgroundColor = 'transparent';
                        }
                    }
                });
                
                // Mock existing files
                if (vm.servicio_json.archivos_adjuntos) {
                    vm.servicio_json.archivos_adjuntos.forEach(function(file) {
                        var mockFile = { name: file.name, size: file.size, path: file.path, isMock: true, url: file.url, type: file.mime };
                        myDropzone.emit("addedfile", mockFile);
                        
                        if(file.url && file.mime && file.mime.match(/^image\//)) {
                            myDropzone.emit("thumbnail", mockFile, file.url);
                        }

                        myDropzone.emit("complete", mockFile);
                        myDropzone.files.push(mockFile);

                        // Click to open existing
                        if(file.url) {
                            mockFile.previewElement.style.cursor = "pointer";
                            mockFile.previewElement.addEventListener("click", function(e) {
                                if (e.target.hasAttribute('data-dz-remove') || e.target.closest('[data-dz-remove]')) {
                                    return;
                                }
                                window.open(file.url, '_blank');
                            });
                        }
                    });
                }

                this.on("success", function(file, response) {
                     // Store file metadata
                     file.serverData = response;
                     vm.archivos_nuevos.push(response);

                     // Add click listener
                     if(response.url) {
                        file.previewElement.style.cursor = "pointer";
                        file.previewElement.addEventListener("click", function(e) {
                            if (e.target.hasAttribute('data-dz-remove') || e.target.closest('[data-dz-remove]')) {
                                return;
                            }
                            window.open(response.url, '_blank');
                        });
                     }
                });

                this.on("removedfile", function(file) {
                    if (file.isMock) {
                        vm.eliminar_archivos.push(file.path);
                    } else if (file.serverData) {
                        // Remove from archivos_nuevos
                        vm.archivos_nuevos = vm.archivos_nuevos.filter(f => f.path !== file.serverData.path);
                    }
                });
            }
        });
    },
    methods: {
        changeAgendable(variable) {
            if (
                !this.servicio_json.agendable &&
                this.servicio_json["agendable_" + variable]
            ) {
                $("#cb-agendable").click();
            }
        },
        handleAgendableChange() {
            if (!this.servicio_json.agendable) {
                if ($("#cb-agendable-web").is(":checked")) {
                    $("#cb-agendable-web").click();
                }
                if ($("#cb-agendable-ejecutivo").is(":checked")) {
                    $("#cb-agendable-ejecutivo").click();
                }
                if ($("#cb-agendable-whatsapp").is(":checked")) {
                    $("#cb-agendable-whatsapp").click();
                }
                if ($("#cb-agendable-telefono").is(":checked")) {
                    $("#cb-agendable-telefono").click();
                }
            }
        },
        add() {
            let x = {
                establecimientos: this.establecimientos_list,
                estrategia: "",
                tipo_citas: [],
                id: null,
            };
            this.list.push(x);
        },
        save() {
            // this.servicio_json = this.list;
            let flag = true;
            let establecimientos = [];
            let array_objects = [];
            let temp = [];
            this.servicio_json["id"] = this.id;
            this.servicio_json["list"] = this.list.map((element, index) => {
                if (!this.filtrar_vacio(element, index) || !flag) {
                    flag = false;
                    return;
                }
                establecimientos = [];
                if (flag)
                    for (const element2 of element.establecimientos) {
                        establecimientos.push(element2.id);

                        for (
                            let index2 = 0;
                            index2 < element.tipo_citas.length;
                            index2++
                        ) {
                            let obj = {
                                id_establecimiento: element2.id,
                                establecimiento_nombre: element2.nombre,
                                id_tipo_cita: element.tipo_citas[index2].id,
                                tipo_cita_abrev:
                                    element.tipo_citas[index2].abrev,
                                indice: index + 1,
                            };
                            temp = array_objects.filter((filtro) => {
                                return (
                                    filtro.id_establecimiento ==
                                        obj.id_establecimiento &&
                                    filtro.id_tipo_cita == obj.id_tipo_cita
                                );
                            });

                            if (temp.length > 0) {
                                this.$swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: "Oops...",
                                    text:
                                        'ERROR "' +
                                        temp[0].establecimiento_nombre +
                                        '" se repite con el mismo tipo de cita en establecimiento ' +
                                        temp[0].indice +
                                        " y establecimiento " +
                                        obj.indice +
                                        "!",
                                    showConfirmButton: true,
                                    timer: 5000,
                                });
                                flag = false;
                                break;
                            } else {
                                array_objects.push(obj);
                            }
                        }

                        if (!flag) break;
                    }
                return {
                    establecimientos: establecimientos,
                    estrategia: element.estrategia,
                    tipo_citas: element.tipo_citas.map((element3) => {
                        return element3.id;
                    }),
                    id: element.id,
                };
            });
            if (!flag) {
                return;
            }

            let formData = new FormData();
            formData.append("id", this.servicio_json.id);
            formData.append("nombre", this.servicio_json.nombre || "");
            formData.append(
                "confirmable",
                this.servicio_json.confirmable ? 1 : 0
            );
            formData.append(
                "confirmable_general",
                this.servicio_json.confirmable_general ? 1 : 0
            );
            formData.append(
                "mensaje_confirmacion",
                this.servicio_json.mensaje_confirmacion || ""
            );
            formData.append(
                "piso_atencion",
                this.servicio_json.piso_atencion || ""
            );
            formData.append(
                "dias_preparacion",
                this.servicio_json.dias_preparacion || 0
            );
            formData.append("agendable", this.servicio_json.agendable ? 1 : 0);
            formData.append(
                "agendable_web",
                this.servicio_json.agendable_web ? 1 : 0
            );
            formData.append(
                "agendable_ejecutivo",
                this.servicio_json.agendable_ejecutivo ? 1 : 0
            );
            formData.append(
                "agendable_whatsapp",
                this.servicio_json.agendable_whatsapp ? 1 : 0
            );
            formData.append(
                "agendable_telefono",
                this.servicio_json.agendable_telefono ? 1 : 0
            );
            formData.append("id_flujo", this.servicio_json.id_flujo || 1);
            formData.append(
                "indicaciones",
                this.servicio_json.indicaciones || ""
            );
            formData.append(
                "texto_personalizado_agendamiento",
                this.servicio_json.texto_personalizado_agendamiento || ""
            );
            formData.append(
                "label_video_explicativo",
                this.servicio_json.label_video_explicativo || ""
            );
            formData.append(
                "url_video_explicativo",
                this.servicio_json.url_video_explicativo || ""
            );

            // JSON fields
            formData.append("list", JSON.stringify(this.servicio_json.list));
            formData.append(
                "eliminar_archivos",
                JSON.stringify(this.eliminar_archivos)
            );

            // Files
            // Files (New approach: send JSON metadata)
            for (let i = 0; i < this.archivos_nuevos.length; i++) {
                 formData.append("archivos_adjuntos[" + i + "]", JSON.stringify(this.archivos_nuevos[i]));
            }
            
            // Deleted files
            for (let i = 0; i < this.eliminar_archivos.length; i++) {
                formData.append("eliminar_archivos[" + i + "]", this.eliminar_archivos[i]);
            }

            axios
                .post("", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    console.log(response);
                    window.history.back(); /*  */
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        eliminar(index) {
            this.list.splice(index, 1);
        },
        filtrar_vacio(element, index) {
            if (element.establecimientos.length == 0) {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "Los establecimientos No." +
                        (index + 1) +
                        " no pueden quedar vacios!",
                    showConfirmButton: true,
                    timer: 3000,
                });
                return false;
            }
            if (element.estrategia == "") {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "La estrategia No." +
                        (index + 1) +
                        " no puede quedar vacia!",
                    showConfirmButton: true,
                    timer: 3000,
                });
                return false;
            }
            if (element.tipo_citas.length == 0) {
                this.$swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Oops...",
                    text:
                        "Los Tipo Cita No." +
                        (index + 1) +
                        " no pueden quedar vacios!",
                    showConfirmButton: true,
                    timer: 3000,
                });
                return false;
            }

            return true;
        },
    },
};
</script>

<style>
.dropzone .dz-preview .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
